import ExcelJS from "exceljs";
import { type Table, type RowData } from "@tanstack/react-table";

export const exportExcel = async <TData extends RowData>(
  table: Table<TData>
) => {
  const excel = new ExcelJS.Workbook();
  excel.creator = "ZUSF";
  excel.created = new Date();
  excel.modified = new Date();

  const sheet = excel.addWorksheet("PAGE", {
    views: [{ showGridLines: false }],
  });
  sheet.addTable({
    name: "UserCustomerData",
    ref: "A1",
    headerRow: true,
    style: {
      theme: "TableStyleLight12",
      showRowStripes: true,
    },
    columns:
      table
        .getHeaderGroups()[0]
        ?.headers.filter(
          (header) => !!header.column.columnDef.header?.toString()
        )
        .map((header) => ({
          name: header.column.columnDef.header?.toString() || "unknown",
        })) ?? [],
    rows: table.getRowModel().rows.map((row) =>
      row
        .getVisibleCells()
        .filter((row) => {
          return !!row.column.columnDef.header?.toString();
        })
        .map((cell) => cell.getValue())
    ),
  });

  const buffer = await excel.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  return URL.createObjectURL(blob);
};
